import Vue from 'vue';
import PricingPage from './PricingPage';

Vue.component('pricing-page', PricingPage);